module.exports = __webpack_public_path__ + "img/grey_030.34306375.png";